<div class="card-table-details">
  <nf-table-layout
    hideTitle
    *nfLoader="loading"
    hideSearch
    [autoResizeGrid]="false"
    [isSectionTitle]="false"
    [gridOptions]="gridOptionsAggregateDetails"
    [data]="aggregateDetailsData"
    hideClearAll
  >
  </nf-table-layout>
</div>
